export const searchText = 'Buscar'